
import { QUEEUE_COLECTION_DATA, QUEEUE_COLECTION_DATA_COMPLETE, QUEEUE_COLECTION_DATA_PASS, QUEEUE_DATA, QUEEUE_DATA_COMPLETE, QUEEUE_DATA_PASS, QUEEUE_PYSICAL_DATA, QUEEUE_PYSICAL_DATA_COMPLETE, QUEEUE_PYSICAL_DATA_PASS } from "./queueService";

const initState = {
  queueData: [],
  queueDataPass: [],
  queueDataComplete: [],
  queuePhysicalData: [],
  queuePhysicalDataPass: [],
  queuePhysicalDataComplete: [],
  queueCollectionData: [],
  queueCollectionDataPass: [],
  queueCollectionDataComplete: [],
}

export const queueDataReducer = (state = initState, action = {}) => {
  switch (action.type) {
    case QUEEUE_DATA:
      return { ...state, queueData: [...action.queueData] }
    case QUEEUE_DATA_PASS:
      return { ...state, queueDataPass: [...action.queueDataPass] }
    case QUEEUE_DATA_COMPLETE:
      return { ...state, queueDataComplete: [...action.queueDataComplete] }
    case QUEEUE_PYSICAL_DATA:
      return { ...state, queuePhysicalData: [...action.queuePhysicalData] }
    case QUEEUE_PYSICAL_DATA_PASS:
      return { ...state, queuePhysicalDataPass: [...action.queuePhysicalDataPass] }
    case QUEEUE_PYSICAL_DATA_COMPLETE:
      return { ...state, queuePhysicalDataComplete: [...action.queuePhysicalDataComplete] }
    case QUEEUE_COLECTION_DATA:
      return { ...state, queueCollectionData: [...action.queueCollectionData] }
    case QUEEUE_COLECTION_DATA_PASS:
      return { ...state, queueCollectionDataPass: [...action.queueCollectionDataPass] }
    case QUEEUE_COLECTION_DATA_COMPLETE:
      return { ...state, queueCollectionDataComplete: [...action.queueCollectionDataComplete] }
    default:
      return state
  }
}
